var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame6972X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 8.25V13.25H20.25V10L24.5 14.25L20.25 18.5V15.25H15.25V20.25H18.5L14.25 24.5L10 20.25H13.25V15.25H8.25V18.5L4 14.25L8.25 10V13.25H13.25V8.25H10L14.25 4L18.5 8.25H15.25Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame6972X);
export default __webpack_public_path__ + "static/media/Frame 697@2x.c1ee6659f635e5d13898bbc5868d96b9.svg";
export { ForwardRef as ReactComponent };